import { FC, useEffect, useState } from 'react';

import { SidebarContext } from './context.ts';
import { TSidebarProviderProps } from './types.ts';

const STORAGE_KEY = 'sidebar_collapsed';

export const SidebarProvider: FC<TSidebarProviderProps> = ({ children }) => {
    const [collapsed, setCollapsedState] = useState<boolean>(() => {
        const stored = localStorage.getItem(STORAGE_KEY);

        return stored === 'true';
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, String(collapsed));
    }, [collapsed]);

    const setCollapsed = (value: boolean): void => {
        setCollapsedState(value);
    };

    const toggleCollapsed = (): void => {
        setCollapsedState((prev) => !prev);
    };

    return (
        <SidebarContext.Provider
            value={{
                collapsed,
                setCollapsed,
                toggleCollapsed,
            }}
        >
            {children}
        </SidebarContext.Provider>
    );
};
